import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import { Modal, Button, Alert } from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";

const useStyles = makeStyles({
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
});

const initialValues = {
  name: "",
  middleName: "",
  surname: "",
  duty: "",
  personalNumber: "",
  supervisor: "",
};

const EditSchema = Yup.object().shape({
  name: Yup.string().required("Ad daxil edilməlidir"),
  middleName: Yup.string().required("Ata adı daxil edilməlidir"),
  surname: Yup.string().required("Soyad daxil edilməlidir"),
  // duty: Yup.string().required("Vəzifə daxil edilməlidir"),
  // personalNumber: Yup.string().required("Şəxsi nömrə daxil edilməlidir"),
  // supervisor: Yup.string().required("Rəhbər daxil edilməlidir"),
});

export default function Edit(props) {
  const classes = useStyles();
  const {
    onHide,
    show,
    onSaps,
    chooseSapId,
    onSapChoose,
    skip,
    take,
    sortField,
    orderBy,
    filterInputs,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      setIsEditLoading(true);

      axios
        .put(`${process.env.REACT_APP_API_URL}employee/${chooseSapId}`, values)
        .then(() => {
          onHide(false);
          resetForm();
          setSubmitting(false);
          onSaps(orderBy, sortField, skip, take, filterInputs);
          setIsEditLoading(false);
        })
        .catch((err) => {
          let message =
            typeof err.response !== "undefined"
              ? err.response.data.message
              : err.message;
          setIsError(message);
          setIsEditLoading(false);
        });
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    setValues,
  } = formik;

  useEffect(() => {
    setIsLoading(true);
    onSapChoose(chooseSapId)
      .then((res) => {
        if (res?.data) {
          setValues({
            name: res.data.name || "",
            middleName: res.data.middleName || "",
            surname: res.data.surname || "",
            duty: res.data.duty || "",
            personalNumber: res.data.personalNumber || "",
            supervisor: res.data.supervisor || "",
          });
        }
        setIsLoading(false);
        setIsError(false);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseSapId, setValues, onSapChoose]);

  const formatPhone = (value) => {
    let digits = value.replace(/\D/g, "");

    if (!digits.startsWith("994")) {
      digits = "994" + digits;
    }

    digits = digits.substring(0, 12);

    let result = "+994";
    if (digits.length > 3) result += " " + digits.substring(3, 5);
    if (digits.length > 5) result += " " + digits.substring(5, 8);
    if (digits.length > 8) result += " " + digits.substring(8, 10);
    if (digits.length > 10) result += " " + digits.substring(10, 12);

    return result;
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
      show={show}
      onHide={onHide}
    >
      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading ? (
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="edit">Düzəliş et</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">
                {[
                  { label: "Ad", name: "name" },
                  { label: "Ata adı", name: "middleName" },
                  { label: "Soyad", name: "surname" },
                  { label: "Vəzifə", name: "duty" },
                  { label: "Şəxsi nömrə", name: "personalNumber" },
                  { label: "Rəhbər", name: "supervisor" },
                ].map((field) => (
                  <div className="col-12 col-md-6 mb-3" key={field.name}>
                    <label>{field.label}</label>
                    {field.name === "personalNumber" ? (
                      <input
                        type="text"
                        className="form-control"
                        name={field.name}
                        value={values.personalNumber}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "personalNumber",
                            formatPhone(e.target.value)
                          )
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        name={field.name}
                        value={values[field.name]}
                        onChange={handleChange}
                      />
                    )}

                    {touched[field.name] && errors[field.name] && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {errors[field.name]}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Ləğv et
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}
